define('pimSearchCompareColumnView',[
  'module',
  'marionette',
  'app',
  'jquery',
  'underscore',
  'settings',
  'bootbox',
  'pimUtil',
  'customersPopupSelectView',
  'template!pimSearchCompareColumnTpl',
  'entities/pim_product',
  'entities/product',
  'entities/orders'
], function (
  module,
  Marionette,
  App,
  $,
  _,
  Settings,
  bootbox,
  PimUtil,
  CustomersPopupSelectView,
  columnTpl
) {
  'use strict';

  // Per-product selections (quantity, print zones, options) are persisted here
  // keyed by product id, so they survive removing a sibling column from the
  // compare list (which re-renders every column) and full page reloads.
  var CONFIG_STORAGE_KEY = 'pim:compare:config';

  function readConfigMap() {
    try {
      var raw = window.localStorage.getItem(CONFIG_STORAGE_KEY);
      var map = raw ? JSON.parse(raw) : {};
      return (map && typeof map === 'object') ? map : {};
    } catch (e) { return {}; }
  }

  function writeConfigMap(map) {
    try { window.localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(map || {})); } catch (e) { /* no-op */ }
  }

  var PimSearchCompareColumnView = Marionette.ItemView.extend({
    template: columnTpl,
    className: 'pim-compare-col pf-fast-calculator',

    ui: {
      quantity: '.js-col-qty',
      calc: '.js-col-calc',
      remove: '.js-col-remove',
      createOffer: '.js-col-create-offer',
      total: '.js-col-total',
      unit: '.js-col-unit',
      margin: '.js-col-margin',
      breakdown: '.js-col-breakdown',
      empty: '.js-col-empty',
      blockLoading: '.js-col-loading',
      stockBlock: '.js-col-stock',
      stockTotal: '.js-col-stock-total',
      stockBreakdown: '.js-col-stock-breakdown'
    },

    events: {
      'click @ui.calc': 'onCalcClick',
      'click @ui.remove': 'onRemoveClick',
      'click @ui.createOffer': 'onCreateOfferClick',
      'change @ui.quantity': 'onQtyChange',
      'click .dropdown-menu-printzone a': 'onChangePrintZone',
      'click .dropdown-menu-option a': 'onChangeOption'
    },

    initialize: function () {
      this.config = {
        quantity: this.options.initialQuantity || 50,
        printZones: {},
        options: {}
      };
      this._restoreSavedConfig();
      this._lastPrice = null;
      this._stocks = null;
      this._stockFetchStarted = false;
    },

    _productKey: function () {
      var id = this.options.pimProduct && this.options.pimProduct.get('id');
      return (id !== null && id !== undefined) ? String(id) : null;
    },

    // Load this product's previously selected quantity / print zones / options.
    _restoreSavedConfig: function () {
      var key = this._productKey();
      if (!key) { return; }
      var saved = readConfigMap()[key];
      if (!saved) { return; }
      if (typeof saved.quantity === 'number' && saved.quantity > 0) {
        this.config.quantity = saved.quantity;
      }
      if (saved.printZones && typeof saved.printZones === 'object') {
        this.config.printZones = saved.printZones;
      }
      if (saved.options && typeof saved.options === 'object') {
        this.config.options = saved.options;
      }
    },

    // Persist this column's current selection so it survives sibling removal
    // and page reloads.
    _persistConfig: function () {
      var key = this._productKey();
      if (!key) { return; }
      var map = readConfigMap();
      map[key] = {
        quantity: this.config.quantity,
        printZones: this.config.printZones,
        options: this.config.options
      };
      writeConfigMap(map);
    },

    // Reflect the restored selection in the dropdown labels after a render.
    _restoreSelectionLabels: function () {
      var that = this;

      _.each(this.config.printZones, function (sel, index) {
        if (!sel) { return; }
        var $a = that.$('.dropdown-menu-printzone a').filter(function () {
          var $el = $(this);
          return String($el.data('index')) === String(index) &&
            String($el.data('pzId')) === String(sel.pzId) &&
            String($el.data('nbColor')) === String(sel.nbrColor);
        }).first();
        if ($a.length) {
          that.$('.printzone-' + index + '-label').text($a.text());
        }
      });

      _.each(this.config.options, function (optionId, index) {
        if (optionId === null || optionId === undefined) { return; }
        var $a = that.$('.dropdown-menu-option a').filter(function () {
          var $el = $(this);
          return String($el.data('index')) === String(index) &&
            String($el.data('optionId')) === String(optionId);
        }).first();
        if ($a.length) {
          that.$('.option-' + index + '-label').text($a.text());
        }
      });
    },

    serializeData: function () {
      var model = this.options.pimProduct;
      var data = model.get('data') ? model.get('data').toJSON() : {};
      var resProduct = model.getCurrentResProduct ? model.getCurrentResProduct() : null;
      var img = this._getImage(model);

      var printAreas = [];
      _.each(data.printAreas || [], function (pa) {
        var paName = (pa.name && pa.name.values) ? PimUtil.getTranslation(pa.name.values) : '';
        var pzs = [];
        _.each(pa.printZones || [], function (pz) {
          var pzName = (pz.refImprintTechnology && pz.refImprintTechnology.name && pz.refImprintTechnology.name.values) ?
            PimUtil.getTranslation(pz.refImprintTechnology.name.values) : '';
          pzs.push({
            id: pz.pimId,
            name: pzName,
            width: pz.width,
            height: pz.height,
            colorModeType: pz.colorModeType,
            maxColors: pz.maxColors
          });
        });
        printAreas.push({ name: paName, unit: 'mm', printZones: pzs });
      });

      var productOptionCategories = [];
      _.each(data.productOptionCategories || [], function (poc) {
        var pocName = (poc.name && poc.name.values) ? PimUtil.getTranslation(poc.name.values) : '';
        var pos = [];
        _.each(poc.productOptions || [], function (po) {
          var poName = (po.name && po.name.values) ? PimUtil.getTranslation(po.name.values) : '';
          pos.push({ id: po.pimId, name: poName });
        });
        productOptionCategories.push({ name: pocName, productOptions: pos });
      });

      var productName = '';
      if (data.name && data.name.values) {
        productName = PimUtil.getTranslation(data.name.values);
      }

      var supplierName = model.get('supplier') || '';
      var productCode = (resProduct && resProduct.get('code')) || data.code || '';
      var supplierCode = data.code || '';

      return {
        productName: productName,
        productCode: productCode,
        supplierCode: supplierCode,
        supplierName: supplierName,
        productId: model.get('id'),
        img: img,
        printAreas: printAreas,
        productOptionCategories: productOptionCategories,
        quantity: this.config.quantity,
        canCompute: !!resProduct
      };
    },

    _getImage: function (model) {
      try {
        var resArr = model.get('resellerData');
        var resModels = resArr && resArr.models ? resArr.models : (resArr || []);
        if (resModels.length > 0) {
          var first = resModels[0].get ? resModels[0] : null;
          var uid = first && first.get('catalogPictureUid');
          if (uid) {
            return Settings.url('file', uid) + '&cmds=on';
          }
        }
      } catch (e) {}
      try {
        var url = model.get('data') && model.get('data').get('catalogPictureUrl');
        if (url) { return url; }
      } catch (e2) {}
      return Settings.get('notFoundImage');
    },

    setQuantity: function (q) {
      this.config.quantity = q;
      if (this.ui.quantity && this.ui.quantity.length) {
        this.ui.quantity.val(q);
      }
      this._persistConfig();
    },

    onQtyChange: function () {
      var v = parseInt(this.ui.quantity.val(), 10);
      if (!isNaN(v) && v > 0) {
        this.config.quantity = v;
        this._persistConfig();
      }
    },

    onChangePrintZone: function (e) {
      e.preventDefault();
      var $a = $(e.target).closest('a');
      var index = $a.data('index');
      var pzId = $a.data('pzId');
      var nbrColor = $a.data('nbColor');
      this.$el.find('.printzone-' + index + '-label').text($a.text());
      if (pzId === -1 || pzId === '-1') {
        delete this.config.printZones[index];
      } else {
        this.config.printZones[index] = { pzId: pzId, nbrColor: nbrColor };
      }
      this._persistConfig();
    },

    onChangeOption: function (e) {
      e.preventDefault();
      var $a = $(e.target).closest('a');
      var index = $a.data('index');
      var optionId = $a.data('optionId');
      this.$el.find('.option-' + index + '-label').text($a.text());
      this.config.options[index] = optionId;
      this._persistConfig();
      this._renderStockForSelection();
    },

    onRender: function () {
      this._restoreSelectionLabels();
      if (!this._stockFetchStarted) {
        this._stockFetchStarted = true;
        this._fetchStocks();
      } else {
        this._renderStockForSelection();
      }
    },

    _getResellerProductId: function () {
      var model = this.options.pimProduct;
      try {
        var resCol = model.get('resellerData');
        var resModels = resCol && resCol.models ? resCol.models : (resCol || []);
        if (resModels.length > 0) {
          var first = resModels[0];
          return first && first.get ? first.get('id') : null;
        }
      } catch (e) { /* no-op */ }
      return null;
    },

    _fetchStocks: function () {
      var resId = this._getResellerProductId();
      if (!resId) { return; }
      var url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + resId + '/stocks');
      var that = this;
      $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
          that._stocks = _.isArray(data) ? data : [];
          that._renderStockForSelection();
        },
        error: function () { /* no-op */ }
      });
    },

    _findMatchingStock: function () {
      if (!this._stocks || !this._stocks.length) { return null; }
      var selectedIds = _.values(this.config.options);
      var selectedSet = _.map(selectedIds, function (v) { return String(v); });

      var data = this.options.pimProduct.get('data');
      var variations = data && data.get ? data.get('productCodeVariations') : null;
      var variationsArr = [];
      if (variations && variations.models) {
        variationsArr = variations.models;
      } else if (_.isArray(variations)) {
        variationsArr = variations;
      }

      if (!selectedSet.length) { return null; }

      var matchedCode = null;
      var variationOptionIds = function (o) {
        var pimId = (o && o.get) ? o.get('pimId') : (o && o.pimId);
        return pimId !== null && pimId !== undefined ? String(pimId) : null;
      };
      var idMatchesVariation = function (variationIds) {
        return function (id) { return _.contains(variationIds, id); };
      };
      for (var i = 0; i < variationsArr.length; i++) {
        var v = variationsArr[i];
        var opts = v && v.get ? v.get('productOptions') : (v && v.productOptions);
        var optModels = opts && opts.models ? opts.models : (opts || []);
        if (!optModels.length) { continue; }
        var variationIds = _.map(optModels, variationOptionIds);
        var matches = _.every(selectedSet, idMatchesVariation(variationIds));
        if (matches) {
          matchedCode = (v && v.get) ? v.get('code') : (v && v.code);
          break;
        }
      }
      if (!matchedCode) { return null; }

      for (var s = 0; s < this._stocks.length; s++) {
        if (this._stocks[s] && String(this._stocks[s].code) === String(matchedCode)) {
          return this._stocks[s];
        }
      }
      return null;
    },

    _totalStock: function () {
      if (!this._stocks) { return null; }
      var sum = 0;
      for (var i = 0; i < this._stocks.length; i++) {
        var q = this._stocks[i] && this._stocks[i].currentQuantity;
        if (typeof q === 'string') { q = parseFloat(q); }
        if (typeof q === 'number' && !isNaN(q)) { sum += q; }
      }
      return sum;
    },

    _renderStockForSelection: function () {
      if (!this.ui.stockBlock || !this.ui.stockBlock.length) { return; }
      if (!this._stocks) {
        this.ui.stockBlock.hide();
        return;
      }
      this.ui.stockBlock.show();

      var selectedCount = _.size(this.config.options);
      var match = this._findMatchingStock();
      var i18n = function (k, def) { return _.i18n(k, null, def); };

      if (selectedCount > 0 && match) {
        var q = match.currentQuantity;
        if (typeof q === 'string') { q = parseFloat(q); }
        if (q === null || q === undefined || isNaN(q)) { q = 0; }
        this.ui.stockTotal
          .text(q + ' ' + i18n('compare.inStock', 'in stock'))
          .removeClass('is-empty is-aggregate')
          .toggleClass('is-low', q <= 0)
          .toggleClass('is-good', q > 0);
        var detail = i18n('compare.forSelection', 'for selected options');
        if (match.code) { detail += ' · ' + match.code; }
        if (match.newArrivalQuantity) {
          var eta = match.newArrivalETA ? (' ETA ' + match.newArrivalETA) : '';
          detail += ' (+ ' + match.newArrivalQuantity + eta + ')';
        }
        this.ui.stockBreakdown.text(detail);
      } else if (selectedCount > 0 && !match) {
        this.ui.stockTotal
          .text(i18n('compare.noStockForSelection', 'No stock for this combination'))
          .removeClass('is-good is-aggregate')
          .addClass('is-low is-empty');
        this.ui.stockBreakdown.text('');
      } else {
        var total = this._totalStock();
        this.ui.stockTotal
          .text((total !== null && total !== undefined ? total : 0) + ' ' + i18n('compare.inStockAggregate', 'in stock (all variants)'))
          .removeClass('is-low is-empty')
          .addClass('is-aggregate')
          .toggleClass('is-good', total > 0);
        this.ui.stockBreakdown.text(i18n('compare.pickOptions', 'Pick options for a precise stock figure'));
      }
    },

    onCalcClick: function () {
      this.compute();
    },

    onRemoveClick: function () {
      this.trigger('column:remove');
    },

    // ── Create offer for this product + current configuration ───
    onCreateOfferClick: function () {
      var that = this;
      var resProduct = this.options.pimProduct.getCurrentResProduct ?
        this.options.pimProduct.getCurrentResProduct() : null;
      if (!resProduct) {
        bootbox.alert(_.i18n('compare.noResProduct', null, 'This product has no reseller variant; cannot create an offer.'));
        return;
      }

      var userDialog = new CustomersPopupSelectView({
        onUserSelected: function (model) {
          userDialog.hide();
          if (!model) { return; }
          that._createOfferForCustomer(model.get('endUserId'));
        }
      });
      userDialog.show({ title: _.i18n('dialog.offer.selectCustomer', null, 'Select customer') });
    },

    // Pull a navigable order id out of the create-offer API response. The
    // backend can return either the full order object (purchaseOrderId/poi/secId)
    // or a wrapper { data: ... } / { result: ... }. We also accept a raw string
    // in case some endpoints return the id directly.
    _extractPoi: function (data) {
      if (!data) { return null; }
      if (typeof data === 'string') { return data; }
      if (typeof data === 'number') { return String(data); }
      var candidate = data.purchaseOrderId || data.poi || data.secId || data.id;
      if (candidate) { return candidate; }
      // Try unwrapping common envelopes
      if (data.data) { return this._extractPoi(data.data); }
      if (data.result) { return this._extractPoi(data.result); }
      return null;
    },

    _createOfferForCustomer: function (endUserId) {
      var that = this;
      var resProduct = this.options.pimProduct.getCurrentResProduct();
      var resCode = resProduct.get('code');

      this.ui.blockLoading.show();

      var selectedProduct = App.request('products:model', { code: resCode });
      selectedProduct.fetch(true).done(function () {
        var cCode = selectedProduct.get('cCode');
        if (!cCode) {
          that.ui.blockLoading.hide();
          bootbox.alert(_.i18n('compare.offerFailed', null, 'Could not resolve product code for offer creation.'));
          return;
        }

        var configuration = {
          quantity: that.config.quantity,
          options: _.clone(that.config.options),
          optionsMix: [],
          printZones: _.clone(that.config.printZones),
          printZonesImages: {},
          attachments: [],
          comment: ''
        };

        App.request('kanban:create-from-configuration-pim',
          'offer',
          cCode,
          endUserId,
          endUserId,
          configuration
        ).then(function (data) {
          that.ui.blockLoading.hide();
          App.navigate('orders/' + data.value, { trigger: true });
        }, function () {
          that.ui.blockLoading.hide();
          bootbox.alert(_.i18n('compare.offerFailed', null, 'Failed to create offer.'));
        });
      }).fail(function () {
        that.ui.blockLoading.hide();
        bootbox.alert(_.i18n('compare.offerFailed', null, 'Failed to create offer.'));
      });
    },

    compute: function () {
      var model = this.options.pimProduct;
      var resProduct = model.getCurrentResProduct ? model.getCurrentResProduct() : null;
      if (!resProduct) { return; }

      var cfg = {
        quantity: this.config.quantity,
        options: [],
        printZonesColors: {}
      };
      _.each(this.config.options, function (v) { cfg.options.push(v); });
      _.each(this.config.printZones, function (pzConf) {
        cfg.printZonesColors[pzConf.pzId] = pzConf.nbrColor;
      });

      this.ui.blockLoading.show();
      this.ui.empty.hide();

      var resId = resProduct.get('id');
      var rsReq = App.request('pim:products:get-price-for-configuration', resId, cfg);
      var buyReq = App.request('pim:products:get-price-for-configuration', resId, cfg, true);

      var that = this;
      $.when(rsReq, buyReq).done(function (rsPrice, price) {
        that._renderResult(rsPrice, price);
        that.ui.blockLoading.hide();
      }).fail(function () {
        that.ui.blockLoading.hide();
      });
    },

    _renderResult: function (rsPrice, price) {
      var qty = Number(price.quantity) || this.config.quantity;
      var total = parseFloat(rsPrice.total) || 0;
      var unit = total / qty;
      var margin = total - (parseFloat(price.total) || 0);
      var marginPct = total > 0 ? (margin / total) * 100 : 0;

      this.ui.total.text(total.toFixed(2) + ' €');
      this.ui.unit.text(unit.toFixed(2) + ' €/pc');
      this.ui.margin.text(margin.toFixed(2) + ' € (' + marginPct.toFixed(1) + '%)');

      var rows = [
        ['price.productCost', price.productPrice, rsPrice.productPrice, 'Product cost'],
        ['price.shippingCost', price.shippingCost, rsPrice.shippingCost, 'Shipping cost'],
        ['price.setupCost', price.totalSetupCost, rsPrice.totalSetupCost, 'Setup cost'],
        ['price.printCosts', price.totalUnitCost, rsPrice.totalUnitCost, 'Print costs'],
        ['price.handlingCost', price.totalHandlingCost, rsPrice.totalHandlingCost, 'Handling cost']
      ];

      var html = '';
      for (var i = 0; i < rows.length; i++) {
        var label = _.i18n(rows[i][0], null, rows[i][3]);
        var buy = parseFloat(rows[i][1]) || 0;
        var sell = parseFloat(rows[i][2]) || 0;
        html +=
          '<div class="pim-compare-break-row">' +
          '  <span class="pim-compare-break-label">' + label + '</span>' +
          '  <span class="pim-compare-break-buy">' + buy.toFixed(2) + ' €</span>' +
          '  <span class="pim-compare-break-sell">' + sell.toFixed(2) + ' €</span>' +
          '</div>';
      }
      this.ui.breakdown.html(html);

      this._lastPrice = { total: total, unit: unit, margin: margin };
      this.trigger('column:price', this._lastPrice);
    }
  });

  module.exports = PimSearchCompareColumnView;
});

